import { gql } from '@apollo/client';

export const TESTER_CONSENT_FORMS = gql`
  query Tester($id: ID!) {
    tester(id: $id) {
      project {
        id
        projectConsentForms {
          consentForm {
            name
            filePath
          }
        }
      }
      segment {
        id
      }
      status
    }
  }
`;
